import axios from "axios";

export const ApiPesquisaSatisfacao = axios.create({
  baseURL: process.env.REACT_APP_API_PESQUISA_SATISFACAO_URL,
  headers: {
    "Content-type": "application/json; charset=UTF-8",
  },
});
